import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import Popover from '../Popover';
import { Box } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      height: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(3)
    },
    cardSection: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    },
    labelText: {
      color: theme.palette.grey[600]
    },
    valueText: {
      fontWeight: 500
    }
  };
});

type DetailsCardProps = {
  title?: { label: string; helpText?: string };
  sections: { label: string; helpText?: string; value: JSX.Element | string }[];
  loading: boolean;
};

const DetailsCard: React.FC<DetailsCardProps> = ({ title, sections = [], loading }) => {
  const classes = useStyles();

  const titleComponent = <Typography variant="h6">{title?.label}</Typography>;

  return (
    <Grid component={Paper} className={classes.container}>
      {title &&
        (title.helpText ? (
          <Popover description={title.helpText}>{titleComponent}</Popover>
        ) : (
          titleComponent
        ))}
      <Box
        flex={1}
        display="flex"
        height="100%"
        flexDirection="column"
        justifyContent="space-evenly"
        alignItems="flex-start"
      >
        {sections.map((x, idx) => {
          const labelComponent = <Typography className={classes.labelText}>{x.label}</Typography>;
          return (
            <div key={`card_section_${idx}`} className={classes.cardSection}>
              {x.helpText ? (
                <Popover description={x.helpText}>{labelComponent}</Popover>
              ) : (
                labelComponent
              )}
              <Typography className={classes.valueText}>
                {loading ? <Skeleton /> : x.value ?? '-'}
              </Typography>
            </div>
          );
        })}
      </Box>
    </Grid>
  );
};

export default DetailsCard;
